import { render, staticRenderFns } from "./MyCourseEvaluation.vue?vue&type=template&id=6587c4bb&"
import script from "./MyCourseEvaluation.vue?vue&type=script&lang=js&"
export * from "./MyCourseEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports